/**
 * lastReportAdapter — `GET students/:id/live-reports` (page 1) → `UIParentLastReport | null`.
 *
 * « Dernier bilan » est une ligne de l'onglet Rapports : même réponse, même adaptateur
 * (`toUILiveSessionReport`), même en-tête à l'écran. Ce fichier ne décide que QUELLE ligne.
 * Jamais importé par le DS.
 *
 * Ce que la carte montre en plus de l'en-tête, c'est **`tutor_comment`**, champ plat de
 * `LiveReportResource`, sérialisé sans condition — pas `commented_report` (le bilan structuré,
 * chargé seulement `whenLoaded('commentedReport')`, que la liste n'eager-loade pas).
 *
 * - **une absence** (`isAbsent`, la règle de `toUILiveSessionReport`) se saute jusqu'au dernier
 *   rapport non absent. La liste arrive triée `created_at desc`
 *   (`LiveReportController::getStudentLiveReports`), donc le premier non absent est le bon.
 * - **un rapport V1** n'a ni chapitre ni score : l'en-tête se réduit à la date et au tuteur, le
 *   commentaire reste.
 *
 * La matière vient des chapitres travaillés, PAS de `subjects` : cette clé est opt-in
 * (`?with_subjects=1`) et l'accueil n'ajoute aucun paramètre.
 */
import { type UIParentLastReport } from "../../../ui/types"
import { toUILiveSessionReport, type ApiLiveReportListItem } from "../LiveReports/liveReportListAdapter"
import { type ApiSchoolSubject } from "../shared/schoolSubjectAdapter"

/**
 * Le dernier bilan affichable, ou `null` — aucune ligne, que des absences, ou pas un mot du
 * tuteur : dans les trois cas la section disparaît plutôt que de montrer une carte vide.
 */
export function toUIParentLastReport(
    rows: ApiLiveReportListItem[] | null | undefined,
    apiSubjects: ApiSchoolSubject[] | null | undefined
): UIParentLastReport | null {
    for (const row of rows ?? []) {
        if (row == null) continue
        const report = toUILiveSessionReport(row, apiSubjects)
        if (report.isAbsent) continue

        return report.comment != null && report.date ? { ...report, comment: report.comment } : null
    }
    return null
}
